import { Position } from '../types';
import { STYLES } from '../styles/constants';

export function snapToGrid(position: Position): Position {
  const gridSize = STYLES.grid.size;
  return {
    x: Math.round(position.x / gridSize) * gridSize,
    y: Math.round(position.y / gridSize) * gridSize
  };
}